import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../../../style/_local_icons.scss';

const getStyle = (iconStyle, color) => ({
    ...iconStyle,
    color: color || {}
});

class Icon extends Component {
    static propTypes = {
        name:      PropTypes.string.isRequired, // Icon to display (see FontAwesome docs). This name will be inside className with the prefix.
        prefix:    PropTypes.string, //Prefix for the icon class, default is 'fa'
        className: PropTypes.string, //Classname used in case you want to add another class to the icon.
        onClick:   PropTypes.func, //Listens when the icon is clicked.
        iconStyle: PropTypes.object, // The object with the specific style if needed
        fw:        PropTypes.bool, // true if fixed width
        eqx:       PropTypes.bool, // true if icon path is local
        lg:        PropTypes.bool, // true if large size
        tooltip:   PropTypes.string, //Text for showing in tooltip
        color:     PropTypes.string //Color to set to style property
    };

    static defaultProps = {
        prefix:      'fa',
        localPrefix: 'eqx'
    };

    renderClassname() {
        const {
            name,
            fw,
            lg,
            className,
            prefix,
            localPrefix,
            eqx
        } = this.props;

        return `${prefix} ${
            eqx ? `${localPrefix}-${name} eqx-icon` : `${prefix}-${name}`} ${
            fw ? `${prefix}-fw` : ''} ${
            lg ? `${prefix}-lg` : ''} ${
            className || ''}`;
    }

    render() {
        const {tooltip, color, onClick, iconStyle} = this.props;

        return (

            <i onClick={onClick}
                style={getStyle(iconStyle, color)}
                className={this.renderClassname()}
                title={tooltip}
            />
        );
    }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/ui/element/Icon.jsx